import React, { useState } from "react";
import styles from "../../Works.module.scss";
import { ReactComponent as StarIcon } from "../../../../../assets/images/starIcon.svg";

export default function FeaturedCard({ project, visible, index, onClick }) {
  const [h, setH] = useState(false);
  return (
    <div
      className={`${styles["ps-wrap"]} ${styles["featured"]}`}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(40px)",
        transition: `opacity .6s ease ${index * 0.1}s,transform .6s ease ${index * 0.1}s`,
      }}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      onClick={onClick}
    >
      <div
        className={`${styles["ps-shadow"]} ${styles["s1"]}`}
        style={{
          transform: h
            ? "rotate(3deg) translateY(14px) scale(.97)"
            : "rotate(2deg) translateY(7px)",
        }}
      />
      <div
        className={`${styles["ps-shadow"]} ${styles["s2"]}`}
        style={{
          transform: h
            ? "rotate(-2deg) translateY(8px) scale(.98)"
            : "rotate(-1deg) translateY(4px)",
        }}
      />
      <div
        className={styles["ps-face"]}
        style={{
          transform: h ? "translateY(-8px)" : "translateY(0)",
          boxShadow: h
            ? "0 28px 72px rgba(0,0,0,.12)"
            : "0 2px 12px rgba(0,0,0,.06)",
          cursor: "pointer",
        }}
      >
        <div
          className={styles["ps-gold-bar"]}
          style={{ transform: h ? "scaleX(1)" : "scaleX(0)" }}
        />
        <div className={styles["ps-glow"]} style={{ opacity: h ? 1 : 0 }} />
        <div className={styles["ps-feat-inner"]}>
          {/* left */}
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 16,
              }}
            >
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 5,
                  padding: "4px 12px",
                  background: "#f5a623",
                  color: "#fff",
                  borderRadius: 50,
                  fontSize: "0.68rem",
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                <StarIcon /> Featured Project
              </span>
            </div>
            <p
              style={{
                fontSize: "0.72rem",
                fontWeight: 600,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                color: "#f5a623",
                marginBottom: 6,
              }}
            >
              {project.category}
            </p>
            <h3
              style={{
                fontSize: "1.4rem",
                fontWeight: 700,
                color: "#1e1e1e",
                marginBottom: 12,
                lineHeight: 1.25,
                fontFamily: "Georgia,serif",
              }}
            >
              {project.title}
            </h3>
            <p
              style={{
                fontSize: "0.875rem",
                lineHeight: 1.75,
                color: "#666",
                marginBottom: 20,
              }}
            >
              {project.description}
            </p>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 6,
                marginBottom: 24,
              }}
            >
              {project.tags.map((t) => (
                <span
                  key={t}
                  style={{
                    padding: "4px 12px",
                    borderRadius: 50,
                    fontSize: "0.71rem",
                    fontWeight: 500,
                    background: h ? "#fff8e7" : "#f2f2f0",
                    color: h ? "#b07a10" : "#666",
                    border: `1px solid ${h ? "rgba(245,166,35,.3)" : "#e8e8e4"}`,
                    transition: "all .25s",
                  }}
                >
                  {t}
                </span>
              ))}
            </div>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "9px 20px",
                borderRadius: 9,
                background: "#f5a623",
                color: "#fff",
                fontSize: "0.82rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              View Details →
            </span>
          </div>
          {/* right – metrics */}
          <div className={styles["ps-feat-right"]}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 12,
                marginBottom: 18,
              }}
            >
              {project.metrics.map((m) => (
                <div
                  key={m.label}
                  style={{
                    background: "#f5f5f3",
                    borderRadius: 14,
                    padding: "15px 14px",
                    border: "1px solid #e8e8e4",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "Georgia,serif",
                      fontSize: "1.45rem",
                      color: "#f5a623",
                      lineHeight: 1,
                      fontWeight: 700,
                    }}
                  >
                    {m.value}
                  </div>
                  <div
                    style={{
                      fontSize: "0.66rem",
                      color: "#888",
                      fontWeight: 600,
                      letterSpacing: "0.05em",
                      textTransform: "uppercase",
                      marginTop: 5,
                    }}
                  >
                    {m.label}
                  </div>
                </div>
              ))}
            </div>
            <div
              style={{
                padding: "13px 15px",
                background: "#fffbf0",
                border: "1.5px dashed rgba(245,166,35,.4)",
                borderRadius: 12,
              }}
            >
              <p
                style={{
                  fontSize: "0.78rem",
                  color: "#b07a10",
                  fontStyle: "italic",
                  lineHeight: 1.6,
                  margin: 0,
                }}
              >
                "This project significantly improved operational efficiency and
                client satisfaction, recognized as a flagship delivery."
              </p>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: 16,
            marginTop: 18,
            borderTop: "1px solid #e8e8e4",
            position: "relative",
            zIndex: 1,
          }}
        >
          <span
            style={{
              fontSize: "0.75rem",
              fontWeight: 600,
              letterSpacing: "0.08em",
              color: "#f5a623",
              textTransform: "uppercase",
            }}
          >
            {project.year}
          </span>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: 5,
              fontSize: "0.72rem",
              color: "#666",
              fontWeight: 500,
            }}
          >
            <span
              style={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: "#4ade80",
                display: "inline-block",
              }}
            />
            {project.status}
          </span>
        </div>
      </div>
    </div>
  );
}
